import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectMutation, QueryClient } from '@tanstack/angular-query-experimental';
import { CreateTimesheetTypeRequest, TimesheetTypeService, UpdateTimesheetTypeRequest } from '../../../../api';
import { QueryKey } from '../../../constants/query-key';

@Injectable()
export class TimesheetTypeCommandService {
  private readonly timesheetTypeService = inject(TimesheetTypeService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateTimesheetTypeRequest) =>
      lastValueFrom(this.timesheetTypeService.createTimesheetType(request)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_TYPES] });
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_TYPES_SELECT] });
    },
  }));

  updateMutation = injectMutation(() => ({
    mutationFn: (request: { id: number; body: UpdateTimesheetTypeRequest }) =>
      lastValueFrom(this.timesheetTypeService.updateTimesheetType(request.id, request.body)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_TYPES] });
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_TYPES_SELECT] });
    },
  }));

  deleteMutation = injectMutation(() => ({
    mutationFn: (id: number) =>
      lastValueFrom(this.timesheetTypeService.deleteTimesheetType(id)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_TYPES] });
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TIMESHEET_TYPES_SELECT] });
    },
  }));
}
